import { SEARCH_STARTED, SEARCH_DONE, SEARCH_FAILED } from '../actions/actionTypes'

const initialState = {
  searchResult: {},
  fetching: false,
  error: ''
}

export const search = (state = initialState, action) => {
  switch (action.type) {
    case SEARCH_STARTED: {      
      return {
        ...state,        
        fetching: true
      }
    }    
    case SEARCH_DONE: {
      return {
        ...state,
        searchResult: action.payload.data,
        fetching: false
      }
    }
    case SEARCH_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
